import ImageIcon from "@mui/icons-material/Image";
const SkeletonImg = ({
  width = "100%",
  animation,
  height = "100%",
  color = "#e5e7eb",
  className = "",
  style = {},
  position = "relative",
  radius = "8px",
  display = "flex",
}) => {
  return (
    <div
      className={`${className} ${
        animation === false
          ? ""
          : animation === "pulse"
          ? "animate-pulse"
          : "animate-wave"
      }`}
      style={{
        position,
        borderRadius: radius,
        display,
        width,
        height,
        background: color,
        justifyContent: "center",
        alignItems: "center",
        ...style,
      }}
    >
      <ImageIcon style={{ width: "20%", height: "20%", opacity: 0.5 }} />
    </div>
  );
};
export default SkeletonImg;
